import { ComponentChild, h } from 'preact'
import { PureComponent } from 'preact-compat'
import ReportPrivateMessageModal from './ReportPrivateMessageModal'
import PrivateMessageReportedModal from './PrivateMessageReportedModal'
import Phrase from '../../../libs/translationsUtils/phrase'
import { reportPrivateMessage } from '../../../services/privateMessageService'

interface Props {
  messageId: number
  messageContent: string
  userId: number
  conversationUser: {
    id: number
    username: string
  }
  setAlertMessage: (message: ComponentChild) => void
  hideReportModal: () => void
}

interface State {
  showReportSuccessModal: boolean
  reason: string
  errorMessage?: ComponentChild
}

class ReportPrivateMessage extends PureComponent<Props, State> {
  constructor () {
    super()
    this.state = {
      showReportSuccessModal: false,
      reason: ''
    }
    this.handleReasonChanged = this.handleReasonChanged.bind(this)
    this.handleReportThisMessage = this.handleReportThisMessage.bind(this)
  }

  handleReasonChanged (reason: string) {
    this.setState({ reason })
  }

  async handleReportThisMessage () {
    const { messageId } = this.props
    const { reason } = this.state

    if (reason.length < 3) {
      this.setState({ errorMessage: <Phrase p='privateMessages.reportModal.reasons.error' /> })
      return
    }

    try {
      await reportPrivateMessage(messageId, reason)
      this.setState({ showReportSuccessModal: true })
    } catch (e) {
      this.props.hideReportModal()
      this.props.setAlertMessage(<Phrase p='privateMessages.reportModal.error' /> as any)
    }
  }

  render ({ conversationUser, messageContent, hideReportModal }: Props, { showReportSuccessModal, reason, errorMessage }: State) {
    return (
      <div>
        {showReportSuccessModal
          ? <PrivateMessageReportedModal
              onIUnderstand={hideReportModal}
            />
          : <ReportPrivateMessageModal
              senderUsername={conversationUser.username}
              reportedMessage={messageContent}
              reason={reason}
              onReasonChanged={this.handleReasonChanged}
              onReport={this.handleReportThisMessage}
              onCancel={hideReportModal}
              errorMessage={errorMessage}
            />}
      </div>
    )
  }
}

export default ReportPrivateMessage
